import { render, staticRenderFns } from "./high-question-content.vue?vue&type=template&id=a04a0498&scoped=true"
import script from "./high-question-content.vue?vue&type=script&lang=js"
export * from "./high-question-content.vue?vue&type=script&lang=js"
import style0 from "./high-question-content.vue?vue&type=style&index=0&id=a04a0498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04a0498",
  null
  
)

export default component.exports